import { webServiceCall } from "../services/pantherService";

export async function fetchPaxBalance(guid, paxId) {
  try {
    const result = await webServiceCall("GetPaxBalance", {
      GUId: guid,
      PaxId: paxId,
    });

    if (result && result.success) {
      return result.balance;
    }

    return null;
  } catch (err) {
    console.error("Error fetching Pax balance:", err);
    return null;
  }
}